/* Brownie Points storefront layer (preview). Reads balance from Joy's customer metafield (window.BP), opens Joy's widget for redemption. */
(function () {
  var BP = window.BP || { pts: 0, member: false, name: '' };
  var LADDER = [[350, 5], [700, 10], [1050, 15], [1400, 20]];
  var RATE = 3;
  var TIERS = [['Insider', 0, 1], ['Preferred', 400, 1.25], ['Elite', 750, 1.5]];

  // Preview-only demo: ?bp_demo=5152 shows the signed-in member experience. ?bp_demo=0 shows a new member, ?bp_demo=guest resets.
  // Demo only runs on unpublished themes (preview links). Once this theme is live, ?bp_demo does nothing.
  var DEMO_OK = !(window.Shopify && Shopify.theme && Shopify.theme.role === 'main');
  if (!DEMO_OK) try {
    sessionStorage.removeItem('bp_demo'); sessionStorage.removeItem('bp_spend');
    var hh = document.documentElement;
    if (hh.getAttribute('data-bp-m') !== '1') ['insider', 'preferred', 'elite'].forEach(function (t) { hh.classList.remove('bp-t-' + t); });
  } catch (e) {}
  if (DEMO_OK) try {
    var q = new URLSearchParams(location.search).get('bp_demo');
    if (q !== null) { if (q === 'guest') sessionStorage.removeItem('bp_demo'); else sessionStorage.setItem('bp_demo', q); }
    var d = sessionStorage.getItem('bp_demo');
    var sp = new URLSearchParams(location.search).get('bp_spend');
    if (sp !== null) sessionStorage.setItem('bp_spend', sp);
    if (d !== null && !BP.member) { BP = { pts: parseInt(d, 10) || 0, member: true, name: 'Kirk', demo: true, tiers: true, spend: parseFloat(sessionStorage.getItem('bp_spend') || '310') }; }
  } catch (e) {}

  function fmt(n) { return Number(n || 0).toLocaleString('en-US'); }
  function best(p) { var v = 0; LADDER.forEach(function (r) { if (p >= r[0]) v = r[1]; }); return v; }
  function next(p) { for (var i = 0; i < LADDER.length; i++) if (p < LADDER[i][0]) return LADDER[i]; return null; }
  function dollars(text) { var m = String(text || '').replace(/,/g, '').match(/(\d+(?:\.\d+)?)/); return m ? parseFloat(m[1]) : 0; }

  function tierIdx() {
    var s = BP.spend || 0, i = 0;
    TIERS.forEach(function (t, k) { if (s >= t[1]) i = k; });
    if (BP.tierTag) TIERS.forEach(function (t, k) { if (t[0] === BP.tierTag && k > i) i = k; });
    return i;
  }
  function mult() { return BP.member && BP.tiers ? TIERS[tierIdx()][2] : 1; }
  function money(n) { return '$' + (Math.round(n) === n ? n : n.toFixed(2)); }
  function paintTiers() {
    var on = !!BP.tiers;
    document.querySelectorAll('[data-bp-tiers]').forEach(function (el) { el.hidden = !on || (el.hasAttribute('data-bp-member') && !BP.member); });
    if (!on || !BP.member) return;
    var i = tierIdx(), cur = TIERS[i], nx = TIERS[i + 1], s = BP.spend || 0;
    var h = document.documentElement; TIERS.forEach(function (t) { h.classList.remove('bp-t-' + t[0].toLowerCase()); }); h.classList.add('bp-t-' + cur[0].toLowerCase());
    document.querySelectorAll('[data-bp-tier]').forEach(function (el) { el.textContent = cur[0]; });
    document.querySelectorAll('[data-bp-spend]').forEach(function (el) { el.textContent = money(Math.round(s)); });
    document.querySelectorAll('[data-bp-rate]').forEach(function (el) { el.textContent = String(RATE * cur[2]); });
    document.querySelectorAll('[data-bp-tier-next]').forEach(function (el) {
      el.textContent = nx ? "You're " + money(Math.ceil(nx[1] - s)) + ' away from ' + nx[0] + '.' : "You're Elite, our top status. Thank you.";
    });
    document.querySelectorAll('[data-bp-tier-bar]').forEach(function (el) {
      el.style.width = (nx ? Math.min(100, Math.round((s - cur[1]) / (nx[1] - cur[1]) * 100)) : 100) + '%';
    });
    document.querySelectorAll('[data-bp-tier-card]').forEach(function (el) {
      var k = parseInt(el.getAttribute('data-bp-tier-card'), 10);
      el.classList.toggle('is-current', k === i); el.classList.toggle('is-done', k < i);
    });
  }

  function paint() {
    var p = BP.pts, b = best(p), n = next(p);
    document.querySelectorAll('[data-bp-member]').forEach(function (el) { el.hidden = !BP.member; });
    document.querySelectorAll('[data-bp-guest]').forEach(function (el) { el.hidden = BP.member; });
    document.querySelectorAll('[data-bp-can]').forEach(function (el) { el.hidden = !(BP.member && b > 0); });
    document.querySelectorAll('[data-bp-cant]').forEach(function (el) { el.hidden = !BP.member; });
    document.querySelectorAll('[data-bp-next-c]').forEach(function (el) { el.textContent = n ? ' ' + fmt(n[0] - p) + ' more to $' + n[1] + ' off.' : ''; });
    document.querySelectorAll('[data-bp-pts]').forEach(function (el) { el.textContent = fmt(p); });
    document.querySelectorAll('[data-bp-name]').forEach(function (el) { el.textContent = BP.name || 'there'; });
    document.querySelectorAll('[data-bp-val]').forEach(function (el) { el.textContent = '$' + b; });
    document.querySelectorAll('[data-bp-next]').forEach(function (el) {
      el.textContent = n ? fmt(n[0] - p) + ' points to $' + n[1] + ' off' : '$20 off is ready for your next order';
    });
    document.querySelectorAll('[data-bp-bar]').forEach(function (el) {
      var top = LADDER[LADDER.length - 1][0]; el.style.width = Math.min(100, Math.round(p / top * 100)) + '%';
    });
    document.querySelectorAll('[data-bp-step]').forEach(function (el) {
      el.classList.toggle('is-on', BP.member && p >= parseInt(el.getAttribute('data-bp-step'), 10));
    });
    paintTiers();
    if (BP.demo) document.documentElement.classList.add('bp-demo');
  }

  // Product page: "Earn X Brownie Points" follows the selected price.
  function pdp() {
    var price = document.querySelector('[data-pdp-price]'); var out = document.querySelectorAll('[data-bp-earn-pdp]');
    if (!price || !out.length) return;
    var set = function () { var e = Math.floor(Math.floor(dollars(price.textContent)) * RATE * mult()); out.forEach(function (o) { o.textContent = fmt(e); }); };
    set(); new MutationObserver(set).observe(price, { childList: true, characterData: true, subtree: true });
  }

  // Cart drawer: "This order earns X points" follows the subtotal.
  function cart() {
    var tot = document.querySelector('[data-c-total]'); var out = document.querySelectorAll('[data-bp-earn-cart]');
    if (!tot || !out.length) return;
    var set = function () { var e = Math.floor(Math.floor(dollars(tot.textContent)) * RATE * mult()); out.forEach(function (o) { o.textContent = fmt(e); }); };
    set(); new MutationObserver(set).observe(tot, { childList: true, characterData: true, subtree: true });
  }

  // Open Joy's widget to a page: home, howToEarn, howToRedeem, activities, rewards.
  function openJoy(page) {
    var j = window.joyInstance;
    if (j && typeof window.avadaJoyTrigger === 'function') { try { j.openWidget(); return; } catch (e) {} }
    var r = document.getElementById('bp-rewards');
    if (r) { r.scrollIntoView({ behavior: 'smooth' }); return; }
    location.href = '/pages/brownie-points#bp-rewards';
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-bp-open]'); if (!t) return;
    e.preventDefault();
    if (BP.demo && !window.joyInstance) { alert('Preview: this opens your Brownie Points rewards panel for signed-in customers.'); return; }
    if (window.LP2Cart && t.closest('[data-lp2-drawer]')) window.LP2Cart.close();
    openJoy(t.getAttribute('data-bp-open'));
  });

  // When a reward is redeemed in Joy's panel, put the code on the cart and reopen the drawer.
  window.addEventListener('joy:redeemCoupon', function (e) {
    var d = e.detail || {}; var code = d.code || (d.coupon && d.coupon.code) || d.discountCode || (d.data && d.data.code);
    if (!code) return;
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: code }) })
      .then(function () { if (window.LP2Cart) { window.LP2Cart.refresh(); window.LP2Cart.open(); } })
      .catch(function () {});
  });

  // Joy Redeem in Cart applies codes without a page reload. When any script changes the cart's discount, refresh our drawer totals.
  (function () {
    var t, hit = function (u) { return /\/(cart\/update|discount\/)/.test(String(u || '')); };
    var kick = function () { clearTimeout(t); t = setTimeout(function () { if (window.LP2Cart) window.LP2Cart.refresh(); }, 350); };
    var f = window.fetch; if (f) window.fetch = function (u) { var p = f.apply(this, arguments); if (hit(u && u.url || u)) p.then(kick, function () {}); return p; };
    var o = XMLHttpRequest.prototype.open; XMLHttpRequest.prototype.open = function (m, u) { if (hit(u)) this.addEventListener('load', kick); return o.apply(this, arguments); };
  })();
  // Pound cake box builder: points line under the box total follows the box price.
  function box() {
    var tot = document.querySelector('[data-sum-total]'); var line = document.querySelector('[data-bp-box]');
    if (!tot || !line) return;
    var SIGNUP = 125;
    var set = function () {
      var nc = tot.getAttribute('data-new-cents'), d = Math.floor(nc != null ? Number(nc) / 100 : dollars(tot.textContent)), e = Math.floor(d * RATE * mult()), p = BP.pts || 0;
      line.hidden = !(d > 0);
      line.querySelectorAll('[data-bp-earn-box]').forEach(function (o) { o.textContent = fmt(e); });
      var have = line.querySelector('[data-bp-box-have]'), join = line.querySelector('[data-bp-box-join]');
      if (have) {
        var b = best(p), a = best(p + e);
        have.textContent = b > 0 ? ' You have ' + fmt(p) + ', so $' + b + ' off is ready in your cart.'
          : a > 0 ? " After this box you'll have " + fmt(p + e) + ', enough for $' + a + ' off your next order.'
          : ' You have ' + fmt(p) + '.';
      }
      if (join) {
        var j = best(SIGNUP + e);
        join.textContent = j > 0 ? ' Add your ' + SIGNUP + " sign-up points and that's $" + j + ' off your next order.' : ' Plus ' + SIGNUP + ' points just for joining.';
      }
    };
    set(); new MutationObserver(set).observe(tot, { childList: true, characterData: true, subtree: true });
  }

  function init() { paint(); pdp(); cart(); box(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
